/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import { setActiveWorkspace, setIsNewWorkspace, setWorkspaceGroupData, setWorkspaceGroups } from 'src/store/workspaces/workspaces/actions';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'src/utils/notification';
import { getModules } from 'src/store/workspaces/modules/actions';
import { run as runActions } from '../../../../../store/workspaces/workspaces/run';
import { WorkspaceService } from 'src/api/services/workspaces/Service.workspace';
import store from 'src/store/store';

const ConfirmDeleteDialog = ({ visible, onClose, selectedGroup }) => {
  const workspaces = useSelector((state: any) => state.workspaces);
  const dispatch = useDispatch<any>();
  const [locked, setLocked] = useState(null);
  const group = workspaces.groups.find(g => g.uuid === selectedGroup?.uuid);

  useEffect(() => {
    const source = group?.uuid ? group : JSON.parse(localStorage.getItem('activeWorkspace'));
  
    setLocked(source.locked || false);
    if(source.locked) {
      toast.warning('Workspace is locked!');
      onClose();
    }
  }, [selectedGroup]);

  const onConfirm = async () => {
    if (workspaces.groups.length === 1)
      return toast.warning('Um Tabs nutzen zu können muss min 1 Workspace gesetzt sein');

    const group = selectedGroup || JSON.parse(localStorage.getItem('activeWorkspace'));
    const workspaceService = new WorkspaceService();
    await workspaceService.delete(group.uuid);
    const res = await workspaceService.getAll();
    dispatch(setWorkspaceGroups(res));

    if (group.uuid !== JSON.parse(localStorage.getItem('activeWorkspace'))?.uuid) return onClose();

    const newGroup = res[0];
    localStorage.setItem('activeWorkspace', JSON.stringify(newGroup));
    const resp = await workspaceService.getTabs(newGroup.uuid);

    const ws = resp.data[0];
    await dispatch(setWorkspaceGroupData(resp.data));
    await dispatch(setActiveWorkspace(0));
    store.dispatch(getModules());
    await runActions(ws.data.key, ws.id, ws);
    await dispatch(setIsNewWorkspace(0, false));
    onClose();
  };

  if(locked === null) return;

  return (
    <DialogComponent
      visible={locked ? false : visible}
      header="Workspace löschen"
      showCloseIcon={true}
      close={() => onClose()}
      isModal={true}
      width="300px"
      content="Möchten Sie diesen Workspace wirklich löschen?"
      buttons={[
        {
          click: onConfirm,
          buttonModel: { content: 'Löschen', cssClass: 'e-custom modal-dialog-btn' }
        },
        {
          click: onClose,
          buttonModel: { content: 'Abbrechen', cssClass: 'e-custom modal-dialog-btn' }
        }
      ]}
    />
  );
};

export default ConfirmDeleteDialog;
